export default __webpack_public_path__ + "static/media/B.36652c88.svg";